<template>
    <div class="caidan">
        <main>
            <h2>请选择业务</h2>

            <van-divider :style="{ color: '#ED6A0C', borderColor: '#ED6A0C', padding: '10px 0' }"></van-divider>
            <van-grid :column-num="3" :icon-size=36  style="color: #ED6A0C;" :border="false" >
                <van-grid-item icon="bell" text="污水污泥饲料" @click="go(1)"/>
                <van-grid-item icon="umbrella-circle" text="环保巡查" @click="go(2)"/>
                <van-grid-item icon="browsing-history" text="死猪录入" @click="go(3)"/>
                <van-grid-item icon="add" text="油耗登记" @click="go(5)"/>
                <van-grid-item icon="map-marked" text="行驶记录" @click="go(6)"/>
                <van-grid-item icon="todo-list" text="报表查看" @click="go(7)"/>
                <!-- <van-grid-item icon="location" text="猪粪运载" @click="go(8)"/> -->
                <van-grid-item icon="info" text="举报入口" @click="goTs()"/>
                <van-grid-item icon="gem" text="食堂评选" @click="goSt()"/>
                <van-grid-item icon="gift" text="股东回馈" @click="goHk()"/>
            </van-grid>

            <van-popup v-model="show">
                <br>
                <br>
                    <van-cell-group inset>
                        <van-field
                            v-model="tell"
                            name="账号"
                            label="账号"
                            placeholder="账号"
                            :rules="[{ required: true, message: '请填写账号' }]"
                        />
                        <van-field
                            v-model="password"
                            type="password"
                            name="密码"
                            label="密码"
                            placeholder="密码"
                            :rules="[{ required: true, message: '请填写密码' }]"
                        />
                    </van-cell-group>
                <div style="margin: 30px 16px;">
                    <van-button round block type="danger" @click="submit">
                        提交
                    </van-button>
                </div>
            </van-popup>
        </main>
    </div>
</template>

<script>

export default {
    data() {
        return {             
            radio:'',
            show:false,
            tell:'',
            password:'',
            status:0,
        }
    },
    mounted() {

    }, 
    methods: {
        goTs() {
            this.$router.push('./complaint')
        },
        goSt() {
            this.$router.push('./canteen')
        },
        goHk() {
            this.$router.push('./feedback')
        },
        go(n) {
            this.status = n
            if(n==1) {
                this.$router.push('./sign')
            }
            if(n==7) {
                this.$router.push('./bblogin')
            } else {
                this.show = true;
            }
        },
        submit() {
            if(this.tell=='admin'&&this.password=='777888') {
                if(this.status==2) {
                    this.show = false
                    this.$router.push('./huanbao')
                }
                if(this.status==3) {
                    this.show = false
                    this.$router.push('./upsizhu')
                }
                if(this.status==5) {
                    this.show = false
                    this.$router.push('./nbc')
                }
                if(this.status==6) {
                    this.show = false
                    this.$router.push('./xsjl')
                }
                if(this.status==8) {
                    this.show = false
                    this.$router.push('./zfyz')
                }
            } else {
                this.$toast.fail({
                    message: '账号无效'
                })
            }
        },
    }
};
</script>
<style lang="less" scoped>
    .caidan {
        main {
            padding: 10px 16px 80vh 16px;
            background-color: #f6f6f6;
        }
        h2 {
            text-align: center;
        }
        span{
            font-size: 18px;
            font-weight: 600;
        }
        .van-popup {
            width: 90%;
        }
    }
</style>

